import TRANSACTION_STATSUS from "./custom/transactionStatus";
import ENV from "./custom/env";
import SITE_MAP from "./custom/sitemap";
import POINT_NAME from "./custom/pointName";

export default {
  TRANSACTION_STATSUS, //ポイントトランザクション状況
  SITE_MAP, //新新IC_SiteMap_一般
  ENV, // 環境
  POINT_NAME // ポイント名称
};
